import { create } from 'zustand';

type Store = {
  // Verbatim PSAP `error_details` from the last carrier 422 (UES-11807).
  // Kept out of `useFormState` so it can never leak into the payload.
  addressErrorDetails: string | null;
  setAddressErrorDetails: (details: string | null) => void;
  reset: () => void;
};

export const useAddressErrorState = create<Store>()(set => ({
  addressErrorDetails: null,
  setAddressErrorDetails: details => {
    return set({ addressErrorDetails: details });
  },
  reset: () => {
    return set({ addressErrorDetails: null });
  },
}));
